import { HelpIcon } from './HelpIcon';

export function RadioField({ id, label, value, onChange, error, helpText, required, readOnly, options = [] }) {
  return (
    <div className="fw">
      <label className="fl">
        {label}
        {required && <span className="req"> *</span>}
        {helpText && <HelpIcon text={helpText} id={id} />}
      </label>
      <div style={{ display:'flex', gap:'1.5rem', marginTop:'0.5rem', flexWrap:'wrap' }}>
        {options.map(opt => (
          <label key={opt.value} style={{ display:'flex', alignItems:'center', gap:'0.5rem', cursor:readOnly ? 'default' : 'pointer', fontSize:'0.875rem' }}>
            <input type="radio" name={id} value={opt.value} checked={value === opt.value}
              disabled={readOnly} onChange={() => onChange(opt.value)}
              style={{ width:'16px', height:'16px', cursor:readOnly ? 'default' : 'pointer' }} />
            <span style={{ color:readOnly ? '#94a3b8' : '#1e293b' }}>{opt.label}</span>
          </label>
        ))}
      </div>
      {error && <span className="ferr" role="alert">{error}</span>}
    </div>
  );
}
